export class ProductItemState {
	static NOT_LOGGED_IN = "NOT_LOGGED_IN";
	static LOGGED_IN_NOT_LOADED = "LOGGED_IN_NOT_LOADED";
	static LOGGED_IN_LOADED_NO_ORDER_ABLE = "LOGGED_IN_LOADED_NO_ORDER_ABLE";
	static LOGGED_IN_LOADED_ORDER_ABLE = "LOGGED_IN_LOADED_ORDER_ABLE";
	static LOGGED_IN_NOT_ORDERABLE_SHOW_PRICE_ONLY = "LOGGED_IN_NOT_ORDERABLE_SHOW_PRICE_ONLY";
}